import { render } from "./allGames.vue?vue&type=template&id=0541a2e6"
import script from "./allGames.vue?vue&type=script&lang=js"
export * from "./allGames.vue?vue&type=script&lang=js"

import "@/styles/pt.css?vue&type=style&index=0&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-partnerpage-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__